import React from "react";
import { colors } from "@wrstudios/theme";
import { Container } from "./styled/listing-scroll-to-top";

function ListingScrollToTop(_a) {
  var _b = _a.color,
      color = _b === void 0 ? colors.streams[500] : _b;
  return React.createElement(Container, {
    style: {
      color: color
    }
  }, "Scroll to Top");
}

export default ListingScrollToTop;